import render from './lib/render';
import compile from './lib/compile';

export default {render};

export {compile};



// WEBPACK FOOTER //
// ./src/distribution/micromustache/index.js